/* OSMANLI DOĞAL TAŞ — İLM-İ FİRÂSET / KIYÂFET · El Analizi
   Akış: intro → kimlik(ad/soyad/doğum) → kamera(el fotoğrafı) → MediaPipe el-noktası ölçümü → analiz → sonuç.
   El şekli (avuç oranı + parmak boyu) → dört unsur/mizaç (ahlât-ı erbaa); parmak oranı + başparmak → karakter.
   Cihaz-içi; el fotoğrafı SUNUCUYA GÖNDERİLMEZ, yalnız ölçümler kullanılır. Ürün/kupon diğer modüllerle aynı.
   Firâset ilmi: Aristo'nun fizyonomisi → İslam dünyası (Kindî, Fahreddin er-Râzî · Kitâbü'l-Firâse) → Osmanlı kıyâfetnâmeleri. */
(function () {
  "use strict";
  var kok = document.getElementById("odtFiraset");
  if (!kok) return;
  var CFG = {}; try { CFG = JSON.parse((document.getElementById("odt-fr-cfg") || {}).textContent || "{}"); } catch (e) {}
  var PANEL = CFG.panel || "";
  function E(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]; }); }
  function tl(k) { var t = (k == null ? 0 : k) / 100; return t.toLocaleString("tr-TR", { minimumFractionDigits: t % 1 ? 2 : 0, maximumFractionDigits: 2 }) + " TL"; }

  var durum = { ad: "", soyad: "", gun: 0, ay: 0, yil: 0, kod: "", kupon: "", unsur: "", burc: "", olcum: null };

  /* Sınıflandırma eşikleri. 2026-10-04 düzeltmesi: eski sabit eşikler (avuç 0,82 · parmak 0,72) gerçek
     el oranlarına göre yanlış kalibreydi → 952 kayıtta %96 Hava/Su çıkmıştı (herkes "aynı sonuç").
     Şimdi: başlangıç değerleri antropometrik tahmin; panel ölçüm biriktirdikçe /firaset/esik toplumun
     MEDYANINI döndürür → her eksen yarı yarıya bölünür, dört unsur dengeli dağılır. */
  var ESIK = { avuc: 0.70, parmak: 0.92, bp: 50, yuzuk: 1.02, sdA: 0.07, sdP: 0.09, n: 0 };
  function esikGetir() {
    if (!PANEL) return;
    try {
      fetch(PANEL + "/firaset/esik", { mode: "cors" }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok || !(d.n >= 30)) return;
        if (d.avuc > 0.3 && d.avuc < 1.5) ESIK.avuc = d.avuc;
        if (d.parmak > 0.4 && d.parmak < 1.8) ESIK.parmak = d.parmak;
        if (d.bp > 20 && d.bp < 90) ESIK.bp = d.bp;
        if (d.yuzuk > 0.7 && d.yuzuk < 1.4) ESIK.yuzuk = d.yuzuk;
        ESIK.n = d.n;
      }).catch(function () {});
    } catch (e) {}
  }
  esikGetir();

  /* ---------- Ekran akışı ---------- */
  function sahne(ad) {
    kok.dataset.aktif = ad;
    var hepsi = kok.querySelectorAll("[data-sahne]");
    for (var i = 0; i < hepsi.length; i++) hepsi[i].hidden = (hepsi[i].dataset.sahne !== ad);
    try { window.scrollTo({ top: kok.getBoundingClientRect().top + window.pageYOffset - 12, behavior: "smooth" }); } catch (e) {}
  }

  /* ---------- Yıldız fonu ---------- */
  (function () {
    var w = kok.querySelector(".fr-yildiz"); if (!w) return;
    var n = window.innerWidth < 700 ? 46 : 90, h = "";
    for (var i = 0; i < n; i++) h += '<i style="left:' + (Math.random() * 100).toFixed(2) + "%;top:" + (Math.random() * 100).toFixed(2) + "%;--d:" + (Math.random() * 4).toFixed(2) + 's;--s:' + (Math.random() * 1.6 + .4).toFixed(2) + 'px"></i>';
    w.innerHTML = h;
  })();

  /* ---------- Burç (gerçek güneş burcu) ---------- */
  var BURCLAR = [
    ["Oğlak", 1, 19], ["Kova", 2, 18], ["Balık", 3, 20], ["Koç", 4, 19], ["Boğa", 5, 20], ["İkizler", 6, 20],
    ["Yengeç", 7, 22], ["Aslan", 8, 22], ["Başak", 9, 22], ["Terazi", 10, 22], ["Akrep", 11, 21], ["Yay", 12, 21], ["Oğlak", 12, 31]
  ];
  function burcBul(g, a) { for (var i = 0; i < BURCLAR.length; i++) { var b = BURCLAR[i]; if (a < b[1] || (a === b[1] && g <= b[2])) return b[0]; } return "Oğlak"; }

  /* ---------- Firâset içeriği: dört unsur/mizaç ---------- */
  var FIRASET = {
    toprak: {
      ad: "Toprak Eli", mizac: "Sevdavî Mizaç", glyph: "🜃", renk: "#8a7a52",
      ozet: "Kare avuç, kısa parmaklar — sağlam, sabırlı, gerçekçi bir el.",
      nitelik: [["Isı", "Soğuk"], ["Nem", "Kuru"], ["Ahlât", "Sevda · kara safra"], ["Uzuv", "Dalak"], ["Mevsim", "Sonbahar"], ["Çağ", "Olgunluk"]],
      tabiat: "Firâset ilminde kare avuç ve kısa parmaklar “toprak” tabiatını gösterir: soğuk-kuru sevdavî mizaç. Sabırlı, sadık, ayakları yere basan; söz verince tutan, sağlamı sever.",
      derinlik: "Toprak elli sevdavî mizaç, kadîm tıpta kara safranın (sevda) hâkim olduğu soğuk-kuru tabiattır. Derinden düşünen, acele etmeyen, kalıcıyı seven birisin. Duyguların yüzeyde değil derindedir; sevgin de kırgınlığın da ağır gelir, geç geçer. Kararını tartar, sözünün arkasında durursun. Yalnızlık sana yük değil, dinlenmedir; en iyi işini kendi sessiz ritminde çıkarırsın.",
      guclu: ["Sabır ve kararlılık", "Sadakat, güvenilirlik", "Pratik akıl, el becerisi", "Sözünün eri olmak"],
      golge: ["Kaygı ve karamsarlığa eğilim", "Değişime direnç, katılık", "İçe kapanıp kırgınlık taşıma", "Aşırı temkinle fırsatı kaçırma"],
      isaret: "Avucun kareye yakın oranı ile kısa-güçlü parmaklar, sevdavî toprak tabiatının işaretidir.",
      ask: "Sevgide ağır ve sadıksın; kolay bağlanmaz, bağlanınca kolay kopmazsın. Gösterişli sözden çok emek ve süreklilikle sevdiğini belli edersin. Sana güven veren, sabrına saygı gösteren biriyle kök salarsın.",
      is: "El emeği, düzen, uzmanlık ve sabır isteyen işlerde parlarsın: zanaat, finans, mühendislik, toprak ve gıda, arşiv-koleksiyon. Söz verdiğini bitiren, güvenilir bir yapı taşısın.",
      uyum: { en: "Hava (demevî) seni hafifletir, güldürür; su (balgamî) duygunu yumuşatır.", zor: "İki toprak birbirini ağırlaştırabilir; ateş (safravî) sabrını zorlar." },
      denge: "Sevdavî tabiat soğuk-kurudur; dengesi ısıtan, neşelendiren, kökleyen taşlardadır. Şu taşlar dağılan enerjini toplar, karamsarlığı dağıtır, iradeni sağlamlaştırır:",
      taslar: [["Kaplan Gözü", "dağılan enerjini toplayan denge taşı"], ["Hematit", "topraklayan, iradeni güçlendiren taş"], ["Yeşim", "sabır ve bereket taşı"], ["Sitrin", "karamsarlığı dağıtan güneş taşı"], ["Dumanlı Kuvars", "kara düşünceleri çeken koruyucu taş"]],
      soz: "İmam Fahreddin er-Râzî Kitâbü’l-Firâse’de sağlam ve ölçülü hatları, sabır ile vakarın alâmeti sayar."
    },
    hava: {
      ad: "Hava Eli", mizac: "Demevî Mizaç", glyph: "🜁", renk: "#c9b56a",
      ozet: "Kare avuç, uzun parmaklar — zeki, iletişimci, meraklı bir el.",
      nitelik: [["Isı", "Sıcak"], ["Nem", "Nemli"], ["Ahlât", "Dem · kan"], ["Uzuv", "Kalp"], ["Mevsim", "İlkbahar"], ["Çağ", "Gençlik"]],
      tabiat: "Kare avuç fakat uzun parmaklar “hava” tabiatını gösterir: sıcak-nemli demevî mizaç. Zeki, konuşkan, meraklı, sosyal; fikirlerle yaşar, çabuk öğrenir, insanları birbirine bağlar.",
      derinlik: "Hava elli demevî mizaç, kanın (dem) hâkim olduğu sıcak-nemli tabiattır. Zihnin durmadan çalışır; fikirden fikire, insandan insana kolayca geçersin. Neşeli, konuşkan, meraklısın; hayatı bir sohbet, bir keşif gibi yaşarsın. Bağlı kalmaktan çok özgür kalmayı, seçenekleri açık tutmayı seversin. Ortama renk katan, insanları birbirine bağlayan sensin.",
      guclu: ["Keskin zekâ, hızlı kavrayış", "Güçlü iletişim", "Uyum ve sosyallik", "Merak ve öğrenme aşkı"],
      golge: ["Dağınık dikkat, işi yarım bırakma", "Yüzeysellik, derinleşememe", "Kararsızlık, söz verip unutma", "Fazla uyarımdan çabuk yorulma"],
      isaret: "Kareye yakın avuç üstünde uzun, hareketli parmaklar; demevî hava tabiatının işaretidir.",
      ask: "Aşkta önce zihnin tutuşur: seni güldüren, sohbetine doyamadığın biri. Tekdüzelikten çabuk sıkılır, tazelik ve özgürlük istersin. Sana alan tanıyan, merakına eşlik eden biriyle uçarsın.",
      is: "İletişim, fikir ve çeşitlilik isteyen işler senin: yazarlık, eğitim, pazarlama, medya, aracılık, tasarım. Aynı anda çok topu havada tutabilen çevik bir zihinsin.",
      uyum: { en: "Toprak (sevdavî) seni köklendirir; ateş (safravî) ateşini büyütür.", zor: "İki hava birlikte dağılabilir; su (balgamî) temponu yavaş bulabilir." },
      denge: "Demevî tabiat sıcak-nemli ve hareketlidir; dengesi zihni toplayan, sakinleştiren taşlardadır. Şu taşlar dağınık dikkatini berraklaştırır, ifadeni açar, sükûnet verir:",
      taslar: [["Sodalit", "zihni berraklaştıran iletişim taşı"], ["Akuamarin", "ifadeyi açan huzur taşı"], ["Ametist", "zihni sakinleştiren sükûnet taşı"], ["Kristal Kuvars", "aklı berraklaştıran, güçlendiren taş"], ["Turkuaz", "uyum ve ifade taşı"]],
      soz: "Kıyâfetnâme geleneğinde ince ve hareketli parmaklar, zekâ ve söz ustalığının alâmeti sayılır."
    },
    ates: {
      ad: "Ateş Eli", mizac: "Safravî Mizaç", glyph: "🜂", renk: "#d98b45",
      ozet: "Uzun avuç, kısa parmaklar — enerjik, cesur, öncü bir el.",
      nitelik: [["Isı", "Sıcak"], ["Nem", "Kuru"], ["Ahlât", "Safra · sarı safra"], ["Uzuv", "Öd kesesi"], ["Mevsim", "Yaz"], ["Çağ", "Delikanlılık"]],
      tabiat: "Uzun (dikdörtgen) avuç ve kısa parmaklar “ateş” tabiatını gösterir: sıcak-kuru safravî mizaç. Enerjik, cesur, lider ruhlu, tez canlı; harekete geçer, tutkuyla yaşar, öne çıkar.",
      derinlik: "Ateş elli safravî mizaç, sarı safranın hâkim olduğu sıcak-kuru tabiattır. İçinde durmayan bir enerji, harekete geçme ve öne çıkma isteği taşırsın. Cesur, kararlı, tez canlısın; beklemek sana zor gelir, istediğinin peşinden hızla gidersin. Doğuştan bir öncü, bir başlatıcısın; kıvılcımı ortama sen atarsın. Tutkun kadar öfken de çabuk gelir, çabuk geçer.",
      guclu: ["Cesaret ve girişkenlik", "Liderlik, öncülük", "Yüksek enerji, tutku", "Hızlı karar"],
      golge: ["Sabırsızlık, acele kararlar", "Çabuk parlayan öfke", "Başladığını bitirmeden atlama", "Hükmetme, ben-merkezcilik"],
      isaret: "Uzun avuç üzerinde kısa-güçlü parmaklar ve açık başparmak; safravî ateş tabiatının işaretidir.",
      ask: "Aşkta ateşli ve doğrudansın; istediğini açıkça belli eder, tutku ve heyecan ararsın. Sana ayak uyduran, seni sıkmayan, gözünün içine bakabilen cesur biriyle alevlenirsin.",
      is: "Liderlik, girişim, rekabet ve hız isteyen işler senin: yöneticilik, girişimcilik, hedefli satış, spor, kriz yönetimi, sahne. Öne çıkıp yön veren bir ateşsin.",
      uyum: { en: "Hava (demevî) ateşini besler, coşturur; toprak (sevdavî) seni sağlama alır.", zor: "İki ateş birbirini yakabilir; su (balgamî) hızını fazla yavaş bulur." },
      denge: "Safravî tabiat sıcak-kurudur; dengesi topraklayan, serinleten, öfkeyi yatıştıran taşlardadır. Şu taşlar enerjini odaklar, cesaretini bilgelikle dengeler:",
      taslar: [["Karnelyan", "yaşam enerjini ateşleyen taş"], ["Garnet", "tutku ve hareket taşı"], ["Kaplan Gözü", "cesaret ve odak taşı"], ["Kırmızı Jasper", "topraklayan güç ve canlılık taşı"], ["Sitrin", "neşe ve canlılık taşı"]],
      soz: "Firâset âlimleri açık başparmağı ve güçlü hatları, irade ve cesaretin alâmeti sayar."
    },
    su: {
      ad: "Su Eli", mizac: "Balgamî Mizaç", glyph: "🜄", renk: "#5aa0c9",
      ozet: "Uzun avuç, uzun parmaklar — sezgili, duygusal, ince bir el.",
      nitelik: [["Isı", "Soğuk"], ["Nem", "Nemli"], ["Ahlât", "Balgam"], ["Uzuv", "Dimağ"], ["Mevsim", "Kış"], ["Çağ", "Kemal"]],
      tabiat: "Uzun avuç ve uzun-ince parmaklar “su” tabiatını gösterir: soğuk-nemli balgamî mizaç. Sezgili, duygusal, hayal gücü kuvvetli, şefkatli; derinden hisseder, sanatı ve huzuru sever.",
      derinlik: "Su elli balgamî mizaç, balgamın hâkim olduğu soğuk-nemli tabiattır. Dünyayı önce hissedersin, sonra düşünürsün; sezgin çoğu zaman aklından önde gider. Şefkatli, ince, hayal gücü kuvvetli birisin; başkalarının duygularını bir sünger gibi çekersin. Huzuru, sanatı, derinliği seversin; gürültüden çok akan suyun sükûnetine yakınsın.",
      guclu: ["Güçlü sezgi ve empati", "Hayal gücü, yaratıcılık", "Şefkat ve incelik", "Derin duygusal zekâ"],
      golge: ["Aşırı duygusallık, alınganlık", "Kararsızlık, sürüklenme", "Başkasının derdini fazla yüklenme", "Gerçekten hayale kaçma"],
      isaret: "Uzun avuç üzerinde uzun-ince, esnek parmaklar; balgamî su tabiatının işaretidir.",
      ask: "Aşkta derin ve romantiksin; yüzeysel ilişki seni doyurmaz, ruh eşi ararsın. Sevdiğine tümüyle akar, incelikle sararsın. Duygunu anlayan, seni incitmeyecek şefkatli biriyle huzur bulursun.",
      is: "Sezgi, şefkat ve yaratıcılık isteyen işler senin: sanat, terapi, bakım, danışmanlık, yazarlık, maneviyat. Derinden hisseden, iyileştiren bir susun.",
      uyum: { en: "Toprak (sevdavî) sana güvenli bir kıyı olur; ateş (safravî) seni harekete geçirir.", zor: "İki su birlikte fazla dalgalanır; ateş hassasiyetini zorlayabilir." },
      denge: "Balgamî tabiat soğuk-nemlidir; dengesi ısıtan, canlandıran, sınır çizen taşlardadır. Şu taşlar duygularını dengeler, seni topraklar, iç huzurunu korur:",
      taslar: [["Ay Taşı", "duyguları dengeleyen sezgi taşı"], ["Pembe Kuvars", "kalbi açan sevgi taşı"], ["Akuamarin", "iç huzur veren su taşı"], ["Selenit", "alanı arındıran ışık taşı"], ["Yeşil Aventurin", "kalbi serinleten şifa taşı"]],
      soz: "Kıyâfetnâmeler uzun ve ince parmakları; incelik, sezgi ve sanat kabiliyetinin alâmeti sayar."
    }
  };

  /* ---------- MediaPipe Hands — klasik <script> (iOS Safari uyumlu) ----------
     tasks-vision (ESM import) iOS Safari'de "Can't find variable: require" veriyordu;
     eski Hands klasik betikle yüklenir (import yok) ve mobil Safari'de kanıtlı çalışır. */
  var elModeli = null, mpYukleniyor = null, mpHata = "", handsOrnek = null;
  var HANDS_BASE = "https://cdn.jsdelivr.net/npm/@mediapipe/hands";
  function betikYukle(src) {
    return new Promise(function (res, rej) {
      if (window.Hands) return res();
      var s = document.createElement("script");
      s.src = src; s.async = true; s.crossOrigin = "anonymous";
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error("hands.js yüklenemedi")); };
      document.head.appendChild(s);
    });
  }
  function modelYukle() {
    if (elModeli) return Promise.resolve(elModeli);
    if (mpYukleniyor) return mpYukleniyor;
    mpYukleniyor = betikYukle(HANDS_BASE + "/hands.js").then(function () {
      if (typeof window.Hands === "undefined") throw new Error("Hands global yok");
      // TEK örnek: retry'da yeniden yaratma (ikinci Hands "Module.arguments" bozar).
      if (!handsOrnek) {
        handsOrnek = new window.Hands({ locateFile: function (f) { return HANDS_BASE + "/" + f; } });
        handsOrnek.setOptions({ maxNumHands: 1, modelComplexity: 1, minDetectionConfidence: 0.5, minTrackingConfidence: 0.5 });
        handsOrnek.onResults(function (r) { sonSonuc(r); });
      }
      // Isıtma: ilk send() modeli indirir (initialize() çağırmak Module'ü bozuyor). Hata olursa burada yakalanır.
      var warm = document.createElement("canvas"); warm.width = 64; warm.height = 64;
      return handsOrnek.send({ image: warm }).then(function () { elModeli = handsOrnek; return handsOrnek; });
    });
    mpYukleniyor.catch(function (e) { mpHata = String((e && e.message) || e || "").slice(0, 72); mpYukleniyor = null; });
    return mpYukleniyor;
  }

  function uzunluk(a, b) { var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); }
  function aci(a, b, c) { // b köşesindeki açı (derece)
    var v1 = { x: a.x - b.x, y: a.y - b.y }, v2 = { x: c.x - b.x, y: c.y - b.y };
    var d = (v1.x * v2.x + v1.y * v2.y) / (Math.hypot(v1.x, v1.y) * Math.hypot(v2.x, v2.y) || 1);
    return Math.acos(Math.max(-1, Math.min(1, d))) * 180 / Math.PI;
  }

  /* 21 el-noktasından ölçüm + unsur/karakter çıkar */
  function elOlc(lm, ar) {
    /* MediaPipe noktaları görüntüye göre NORMALİZE (x: 0-1 genişlik, y: 0-1 yükseklik). Kamera dikeyken
       yatay 0,1 ile dikey 0,1 farklı uzunluktur → avuç genişliği/boyu oranı cihaza göre sapıyordu
       (telefonda herkes kare=Hava, masaüstünde herkes uzun=Su). x'i görüntü oranıyla çarpıp gerçek geometriye çeviriyoruz. */
    ar = ar || 1;
    var P = []; for (var i = 0; i < lm.length; i++) P.push({ x: lm[i].x * ar, y: lm[i].y });
    var avucEn = uzunluk(P[5], P[17]);              // işaret MCP ↔ serçe MCP (avuç genişliği)
    var avucBoy = uzunluk(P[0], P[9]);              // bilek ↔ orta MCP (avuç boyu)
    var ortaBoy = uzunluk(P[9], P[12]);             // orta parmak boyu (MCP → uç)
    var isaretBoy = uzunluk(P[5], P[8]);
    var yuzukBoy = uzunluk(P[13], P[16]);
    var bpAci = aci(P[4], P[2], P[5]);              // başparmak açıklığı
    var avucOran = avucEn / (avucBoy || 1);         // kare avuç: büyük; uzun avuç: küçük
    var parmakOran = ortaBoy / (avucBoy || 1);      // uzun parmak: büyük
    var yuzukIsaret = yuzukBoy / (isaretBoy || 1);  // >eşik: yüzük parmağı işaretten uzun

    var kare = avucOran >= ESIK.avuc;               // kare mi uzun mu avuç (toplum medyanına göre)
    var uzunParmak = parmakOran >= ESIK.parmak;
    var unsur = kare ? (uzunParmak ? "hava" : "toprak") : (uzunParmak ? "su" : "ates");

    // Dört unsur profili: eşiğe uzaklık → ağırlık (çarpımlar 1'e toplanır). Baskın = unsur, ikincil = sıradaki.
    function sig(z) { return 1 / (1 + Math.exp(-z)); }
    var k = sig((avucOran - ESIK.avuc) / ESIK.sdA), u = sig((parmakOran - ESIK.parmak) / ESIK.sdP);
    var prof = { hava: k * u, toprak: k * (1 - u), su: (1 - k) * u, ates: (1 - k) * (1 - u) };
    var sira = ["hava", "toprak", "su", "ates"].sort(function (a, b) { return prof[b] - prof[a]; });
    var ikincil = sira[0] === unsur ? sira[1] : sira[0];
    var yuzde = {}; for (var q in prof) yuzde[q] = Math.round(prof[q] * 100);

    // karakter işaretleri
    var kar = [];
    kar.push(bpAci >= ESIK.bp ? ["Açık başparmak", "cömert, özgür iradeli, girişken"] : ["Dar başparmak", "temkinli, disiplinli, ölçülü"]);
    kar.push(yuzukIsaret >= ESIK.yuzuk ? ["Yüzük parmağı baskın", "yaratıcı, risk alan, sanatkâr ruh"] : ["İşaret parmağı baskın", "hırslı, yönetici, sorumluluk sahibi"]);
    kar.push(uzunParmak ? ["Uzun parmaklar", "detaycı, düşünen, sabırlı"] : ["Kısa parmaklar", "hızlı, sonuç odaklı, pratik"]);
    return { unsur: unsur, ikincil: ikincil, profil: yuzde, avucOran: avucOran, parmakOran: parmakOran, bpAci: bpAci, yuzukIsaret: yuzukIsaret, karakter: kar };
  }

  /* ---------- Kamera + canlı el algılama (ön kamera) ---------- */
  var kam = { stream: null };
  var canli = { raf: 0, calisiyor: false, sending: false, sonLm: null, ardArda: 0, kilit: false, ar: 1 };
  var tarama = { aktif: false, samples: [], sure: 15000, gecen: 0, sonKare: 0, elVar: false, raf: 0 };
  var BAG = [[0,1],[1,2],[2,3],[3,4],[0,5],[5,6],[6,7],[7,8],[5,9],[9,10],[10,11],[11,12],[9,13],[13,14],[14,15],[15,16],[13,17],[17,18],[18,19],[19,20],[0,17]];
  function kameraAc() {
    var v = E("frVideo");
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return Promise.reject(new Error("Kamera desteklenmiyor"));
    // ÖN kamera: kullanıcı avucunu ekranda görür (CSS ayna ile doğal). Olmazsa arka/herhangi.
    return navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: "user" }, width: { ideal: 1280 }, height: { ideal: 960 } }, audio: false })
      .catch(function () { return navigator.mediaDevices.getUserMedia({ video: true, audio: false }); })
      .then(function (s) { kam.stream = s; v.srcObject = s; return v.play().then(function () { return s; }); });
  }
  function kameraKapat() {
    donguDur();
    if (tarama.raf) { try { cancelAnimationFrame(tarama.raf); } catch (e) {} tarama.raf = 0; }
    tarama.aktif = false;
    var cer = E("frCerceve"); if (cer) cer.classList.remove("fr-tarama", "fr-var");
    var bar = E("frTaraBar"); if (bar) bar.hidden = true;
    temizleOverlay();
    if (kam.stream) { kam.stream.getTracks().forEach(function (t) { t.stop(); }); kam.stream = null; }
  }

  function frameVar(on) { var c = E("frCerceve"); if (c) c.classList.toggle("fr-var", !!on); }
  function donguDur() { canli.calisiyor = false; if (canli.raf) { try { cancelAnimationFrame(canli.raf); } catch (e) {} canli.raf = 0; } }

  /* Hands her sonuç verdiğinde: eli çiz; sabit görülünce animasyonlu taramayı başlat. */
  function sonSonuc(r) {
    if (kok.dataset.aktif !== "kamera") return;
    var lm = r && r.multiHandLandmarks && r.multiHandLandmarks[0];
    var gecerli = lm && lm.length >= 21;
    var vd = E("frVideo"); if (vd && vd.videoWidth && vd.videoHeight) canli.ar = vd.videoWidth / vd.videoHeight;
    if (gecerli) cizOverlay(lm); else temizleOverlay();
    if (tarama.aktif) {
      tarama.elVar = !!gecerli;
      if (gecerli) { canli.sonLm = lm; tarama.samples.push(lm); }
      return;
    }
    if (gecerli) {
      canli.sonLm = lm; canli.ardArda++; frameVar(true);
      if (!canli.kilit) {
        if (canli.ardArda >= 4) taramaBasla();
        else E("frKamDurum").textContent = "El görülüyor… sabit tut ✋";
      }
    } else {
      canli.sonLm = null; canli.ardArda = 0; frameVar(false);
      if (!canli.kilit) E("frKamDurum").textContent = "✋ Ekranda el yok — avucunu çerçeveye getir · parmaklar açık";
    }
  }

  /* Video üzerine el iskeleti + 21 nokta (object-fit:cover + ayna eşlemesiyle). */
  function temizleOverlay() { var cv = E("frOverlay"); if (cv && cv.width) { cv.getContext("2d").clearRect(0, 0, cv.width, cv.height); } }
  function cizOverlay(lm) {
    var cv = E("frOverlay"), v = E("frVideo"); if (!cv || !v || !v.videoWidth) return;
    var W = cv.clientWidth, H = cv.clientHeight; if (!W || !H) return;
    if (cv.width !== W) cv.width = W; if (cv.height !== H) cv.height = H;
    var ctx = cv.getContext("2d"); ctx.clearRect(0, 0, W, H);
    var vw = v.videoWidth, vh = v.videoHeight, s = Math.max(W / vw, H / vh);
    var dw = vw * s, dh = vh * s, ox = (W - dw) / 2, oy = (H - dh) / 2;
    function P(p) { return [W - (ox + p.x * dw), oy + p.y * dh]; }   // ayna: video scaleX(-1)
    ctx.lineWidth = 2; ctx.strokeStyle = "rgba(227,200,138,.5)"; ctx.beginPath();
    for (var k = 0; k < BAG.length; k++) { var a = P(lm[BAG[k][0]]), b = P(lm[BAG[k][1]]); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); }
    ctx.stroke();
    ctx.fillStyle = "#FFF3D4"; ctx.shadowColor = "rgba(227,200,138,.9)"; ctx.shadowBlur = 8;
    for (var i = 0; i < lm.length; i++) { var q = P(lm[i]); ctx.beginPath(); ctx.arc(q[0], q[1], 3.2, 0, 6.2832); ctx.fill(); }
    ctx.shadowBlur = 0;
  }

  /* Toplanan karelerin ortalaması (kararlı ölçüm; son ~2.4sn). */
  function ortalaLandmark(list) {
    if (!list || !list.length) return null;
    var src = list.length > 24 ? list.slice(list.length - 24) : list, n = src.length, m = src[0].length, out = [];
    for (var i = 0; i < m; i++) { var sx = 0, sy = 0; for (var j = 0; j < n; j++) { sx += src[j][i].x; sy += src[j][i].y; } out.push({ x: sx / n, y: sy / n }); }
    return out;
  }

  /* Animasyonlu tarama: ~3sn ışın + el noktaları + % dolar; ardından ortalanmış ölçümle sonuca geç. */
  function taramaBasla() {
    if (tarama.aktif) return;
    tarama.aktif = true; canli.kilit = true; tarama.samples = [];
    tarama.gecen = 0; tarama.sonKare = performance.now(); tarama.elVar = true;
    if (canli.sonLm) tarama.samples.push(canli.sonLm);
    var b = E("frTara"); if (b) { b.disabled = true; b.textContent = "Taranıyor…"; }
    var cer = E("frCerceve"); if (cer) cer.classList.remove("fr-var");
    var bar = E("frTaraBar"); if (bar) bar.hidden = false;
    var mesajlar = ["Avucun okunuyor…", "Avuç oranı ölçülüyor…", "Parmak boyları inceleniyor…", "Başparmak açısı hesaplanıyor…", "Parmak oranların çıkarılıyor…", "Dört unsur dengen tartılıyor…", "Mizacın belirleniyor…"];
    (function ilerle() {
      var now = performance.now(), dt = now - tarama.sonKare; tarama.sonKare = now;
      if (dt > 200) dt = 200;                         // sekme arka plandaysa sıçramayı engelle
      if (tarama.elVar) tarama.gecen += dt;           // ilerleme YALNIZ el ekrandayken → gerçekten ≥15sn analiz
      var t = tarama.gecen / tarama.sure; if (t > 1) t = 1;
      var yuzde = Math.round(t * 100);
      var dolu = E("frTaraDolu"); if (dolu) dolu.style.width = yuzde + "%";
      var c = E("frCerceve");
      if (tarama.elVar) {
        if (c) c.classList.add("fr-tarama");
        E("frKamDurum").textContent = mesajlar[Math.min(mesajlar.length - 1, Math.floor(t * mesajlar.length))] + "  · %" + yuzde;
      } else {
        if (c) c.classList.remove("fr-tarama");
        E("frKamDurum").textContent = "✋ Ekranda el yok — avucunu çerçevede tut  · %" + yuzde;
      }
      if (t < 1) tarama.raf = requestAnimationFrame(ilerle); else taramaBitir();
    })();
  }

  function taramaBitir() {
    if (tarama.raf) { try { cancelAnimationFrame(tarama.raf); } catch (e) {} tarama.raf = 0; }
    tarama.aktif = false;
    var cer = E("frCerceve"); if (cer) cer.classList.remove("fr-tarama");
    var bar = E("frTaraBar"); if (bar) bar.hidden = true;
    var lm = ortalaLandmark(tarama.samples) || canli.sonLm;
    if (!lm) {
      canli.kilit = false; temizleOverlay(); frameVar(false);
      var b = E("frTara"); if (b) { b.disabled = false; b.textContent = "Elimi Tara"; }
      E("frKamDurum").textContent = "El net okunamadı. Avucunu çerçeveye al, sabit tut; tekrar deneyelim.";
      return;
    }
    durum.olcum = elOlc(lm, canli.ar || 1); durum.unsur = durum.olcum.unsur;
    kameraKapat();
    sahne("analiz");
    setTimeout(function () { sahne("sonuc"); sonucGoster(); }, 1400);
  }

  /* Kareleri sırayla Hands'e gönder (önceki bitmeden yenisini gönderme; ~kamera hızı). */
  function donguBasla() {
    canli.calisiyor = true; canli.sending = false; canli.sonLm = null; canli.ardArda = 0; canli.kilit = false;
    tarama.aktif = false; tarama.samples = []; tarama.gecen = 0; tarama.elVar = false;
    function adim() {
      if (!canli.calisiyor) return;
      canli.raf = requestAnimationFrame(adim);
      var v = E("frVideo");
      if (!kam.stream || !elModeli || canli.sending || !v || v.readyState < 2 || !v.videoWidth) return;
      canli.sending = true;
      try {
        var p = elModeli.send({ image: v });
        if (p && p.then) p.then(function () { canli.sending = false; }, function () { canli.sending = false; });
        else canli.sending = false;
      } catch (e) { canli.sending = false; }
    }
    canli.raf = requestAnimationFrame(adim);
  }


  /* ---------- Kaydet + kupon ---------- */
  function testId() { for (var abc = "ABCDEFGHJKLMNPRTUVWXYZ23456789", r = "", i = 0; i < 8; i++)r += abc.charAt(Math.floor(Math.random() * abc.length)); return "FR-" + r; }
  function r3(x) { return (typeof x === "number" && isFinite(x)) ? Math.round(x * 1000) / 1000 : null; }
  function kaydet() {
    if (!PANEL) return Promise.resolve();
    durum.kod = durum.kod || testId();
    return fetch(PANEL + "/firaset/kaydet", { method: "POST", mode: "cors", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ test_kod: durum.kod, ad: durum.ad, soyad: durum.soyad, unsur: durum.unsur, mizac: (FIRASET[durum.unsur] || {}).mizac || "", burc: durum.burc, dt: durum.gun + "." + durum.ay + "." + durum.yil,
        ikincil: (durum.olcum || {}).ikincil || "", avuc_oran: r3((durum.olcum || {}).avucOran), parmak_oran: r3((durum.olcum || {}).parmakOran),
        bp_aci: r3((durum.olcum || {}).bpAci), yuzuk_isaret: r3((durum.olcum || {}).yuzukIsaret) }) })
      .then(function (r) { return r.json(); }).then(function (res) { if (res && res.kupon) { durum.kupon = res.kupon; } return res; }).catch(function () {});
  }

  function kuponGoster(kod) {
    if (!kod) return; var iz = E("frUrunler"); if (!iz) return;
    var bol = iz.closest ? iz.closest(".fr-bolum") : null; if (!bol) bol = iz;
    var box = E("frKupon");
    if (!box) { box = document.createElement("div"); box.id = "frKupon"; box.className = "fr-kupon"; bol.parentNode.insertBefore(box, bol); }
    box.innerHTML = '<span class="fr-kupon-et">🎁 SANA ÖZEL HEDİYE</span>' +
      '<p class="fr-kupon-a">Elini okuduk — <b>tüm sepetine %10 indirim</b>. 1 hafta geçerli · tek kullanımlık · diğer indirimlerle birleşir.</p>' +
      '<div class="fr-kupon-kod"><code id="frKuponKod">' + esc(kod) + '</code><button type="button" class="fr-kupon-kopya" id="frKuponKopya">Kopyala</button></div>';
    var kb = E("frKuponKopya"); if (kb) kb.onclick = function () {
      var ok = false; try { navigator.clipboard.writeText(kod); ok = true; } catch (e) {}
      if (!ok) { try { var t = document.createElement("textarea"); t.value = kod; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove(); } catch (e2) {} }
      var o = kb.textContent; kb.textContent = "✓ Kopyalandı"; kb.classList.add("ok"); setTimeout(function () { kb.textContent = o; kb.classList.remove("ok"); }, 1900);
    };
  }

  /* ---------- Ürünler (taş adı araması + alakasız ürün filtresi) ---------- */
  var ELE = /bebek|çocuk|cocuk|gua ?sha|masaj|kaz aya|dekor|hediyelik|anahtarl|magnet|çakmak|kolye ucu|takı seti|zincir|kabaşon|kaboşon|kabason/i;
  function urunAra(q) {
    var u = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide";
    return fetch(u, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); })
      .then(function (d) { return (((d.resources || {}).results || {}).products || []); }).catch(function () { return []; });
  }
  function urunDetay(url) { var b = (url || "").split("?")[0]; if (!b) return Promise.resolve(null); return fetch(b + ".js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function ilkVar(p) { var vs = p.variants || []; for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i]; return vs[0] || null; }
  function gorsel(u) { if (!u) return ""; if (u.indexOf("//") === 0) u = "https:" + u; return u.replace(/(\.[a-z]+)(\?|$)/i, "_400x$1$2"); }
  function urunKart(p) {
    var v = ilkVar(p); if (!v) return "";
    var g = gorsel(p.featured_image || (p.images && p.images[0]) || "");
    return '<div class="fr-urun"><a class="fr-urun-lnk" href="' + p.url + '"><div class="fr-urun-g"><img loading="lazy" src="' + g + '" alt="' + esc(p.title || "") + '"></div><div class="fr-urun-ad">' + esc(p.title || "") + '</div></a>' +
      '<div class="fr-urun-alt"><span class="fr-urun-f">' + tl(v.price != null ? v.price : p.price) + '</span><button class="fr-sepet" type="button" data-vid="' + v.id + '" ' + (v.available ? "" : "disabled") + '>' + (v.available ? "Sepete Ekle" : "Tükendi") + "</button></div></div>";
  }
  function urunleriGetir(unsur, burc) {
    var iz = E("frUrunler"); if (!iz) return;
    iz.innerHTML = '<div class="fr-yuk">Eline ve burcuna uygun taşlar getiriliyor…</div>';
    var adlar = (FIRASET[unsur].taslar || []).map(function (t) { return t[0]; });
    adlar.unshift(burc + " Burcu");   // burç ürünü de dahil
    Promise.all(adlar.map(urunAra)).then(function (L) {
      var gor = {}, sec = [], i = 0, gv = 0;
      while (sec.length < 12 && gv < 160) { var l = L[i % L.length], p = l && l.shift(); if (p && p.url && !gor[p.url] && !ELE.test(p.title || "")) { gor[p.url] = 1; sec.push(p); } i++; gv++; if (L.every(function (x) { return !x || !x.length; })) break; }
      if (!sec.length) { iz.innerHTML = '<p class="fr-not">Şu an uygun ürün bulunamadı.</p>'; return; }
      Promise.all(sec.map(function (p) { return urunDetay(p.url); })).then(function (DL) { var k = DL.filter(Boolean).map(urunKart).filter(Boolean); iz.innerHTML = k.length ? k.join("") : '<p class="fr-not">Ürünler yüklenemedi.</p>'; });
    });
  }

  function sepeteEkle(vid, btn) {
    btn.disabled = true; var o = btn.textContent; btn.textContent = "EKLENİYOR…";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.textContent = "STOKTA YOK"; setTimeout(function () { btn.textContent = o; btn.disabled = false; }, 1600); return; }
        btn.textContent = "EKLENDİ ✓"; btn.classList.add("is-ok");
        if (PANEL && durum.kod) { try { fetch(PANEL + "/firaset/sepet", { method: "POST", mode: "cors", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ test_kod: durum.kod }) }).catch(function () {}); } catch (e) {} }
        try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "El Firâseti": durum.kod, "Unsur": (FIRASET[durum.unsur] || {}).ad || "", "Burç": durum.burc } }) }); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent("odt:cart:add")); } catch (e) {}
        setTimeout(function () { btn.textContent = o; btn.disabled = false; btn.classList.remove("is-ok"); }, 2200);
      }).catch(function () { btn.textContent = o; btn.disabled = false; });
  }

  /* ---------- Sonuç render ---------- */
  function sonucGoster() {
    var f = FIRASET[durum.unsur], o = durum.olcum || {};
    E("frHeroGlyph").textContent = f.glyph;
    E("frHeroWrap").style.setProperty("--fr-renk", f.renk);
    E("frSonucBaslik").innerHTML = esc(f.ad) + ' <span class="fr-mizac">' + esc(f.mizac) + "</span>";
    E("frSonucOzet").textContent = f.ozet;

    // Ölçüm raporu (taramadan gelen gerçek değerler)
    if (o.avucOran != null) {
      var rap = [
        ["Avuç oranı", o.avucOran.toFixed(2), o.avucOran >= ESIK.avuc ? "Kareye yakın · sağlam yapı" : "Uzuna yakın · hareketli yapı"],
        ["Parmak / avuç", o.parmakOran.toFixed(2), o.parmakOran >= ESIK.parmak ? "Uzun parmak · düşünen, detaycı" : "Kısa parmak · pratik, hızlı"],
        ["Başparmak açısı", Math.round(o.bpAci) + "°", o.bpAci >= ESIK.bp ? "Açık · özgür, cömert irade" : "Ölçülü · disiplinli irade"]
      ];
      var pr = o.profil || {}, ik = FIRASET[o.ikincil];
      var profil = '<div class="fr-profil">' + ["hava", "toprak", "ates", "su"].map(function (u) {
        var f2 = FIRASET[u], y = pr[u] || 0;
        return '<div class="fr-profil-s' + (u === durum.unsur ? " fr-profil-bas" : "") + '"><span class="fr-profil-ad">' + esc(f2.glyph + " " + f2.ad) + '</span><span class="fr-profil-cubuk"><i style="width:' + y + '%;background:' + f2.renk + '"></i></span><span class="fr-profil-y">%' + y + "</span></div>";
      }).join("") + "</div>" +
        (ik ? '<p class="fr-profil-not">Elinin ölçüleri dört unsura bu oranlarda dağılıyor: baskın unsurun <b>' + esc(f.ad) + '</b>, ikincil unsurun <b>' + esc(ik.ad) + "</b> (" + esc(ik.mizac) + "). " + esc(ik.ozet) + "</p>" : "");
      E("frOlcum").innerHTML = '<div class="fr-olcum"><span class="fr-bolum-et">Elinin Ölçümü</span><div class="fr-olcum-g">' +
        rap.map(function (x) { return '<div class="fr-olcum-k"><span class="fr-olcum-d">' + esc(x[1]) + '</span><b>' + esc(x[0]) + '</b><span class="fr-olcum-y">' + esc(x[2]) + '</span></div>'; }).join("") + "</div>" + profil + "</div>";
    }

    E("frNitelik").innerHTML = "<h3>Mizacının Nitelikleri</h3><div class=\"fr-nitelik-g\">" +
      f.nitelik.map(function (x) { return '<div class="fr-nitelik-k"><span>' + esc(x[0]) + "</span><b>" + esc(x[1]) + "</b></div>"; }).join("") + "</div>";

    E("frTabiat").innerHTML = "<h3>Tabiatın</h3><p>" + esc(f.tabiat) + "</p><p>" + esc(f.derinlik) + "</p>";
    E("frGuclu").innerHTML = "<h3>Güçlü Yanların</h3><ul>" + f.guclu.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>";
    E("frGolge").innerHTML = "<h3>Gölge Yanların</h3><p class=\"fr-golge-not\">Farkında olmak, dengelemenin ilk adımıdır.</p><ul>" + f.golge.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>";

    E("frIsaret").innerHTML = "<h3>Elindeki İşaretler</h3>" +
      '<div class="fr-isaret-g">' + (o.karakter || []).map(function (x) { return '<div class="fr-isaret-k"><b>' + esc(x[0]) + "</b><span>" + esc(x[1]) + "</span></div>"; }).join("") +
      '<div class="fr-isaret-k"><b>' + esc(f.mizac) + "</b><span>" + esc(f.isaret) + "</span></div></div>";

    E("frAsk").innerHTML = "<h3>Aşk &amp; İlişkiler</h3><p>" + esc(f.ask) + "</p>";
    E("frIs").innerHTML = "<h3>İş &amp; Yol</h3><p>" + esc(f.is) + "</p>";
    E("frUyum").innerHTML = "<h3>Uyumlu Mizaçlar</h3><div class=\"fr-uyum-g\">" +
      '<div class="fr-uyum-k fr-uyum-en"><b>✓ Seni tamamlar</b><span>' + esc(f.uyum.en) + "</span></div>" +
      '<div class="fr-uyum-k fr-uyum-zor"><b>△ Zorlayabilir</b><span>' + esc(f.uyum.zor) + "</span></div></div>";

    E("frBurc").innerHTML = "<h3>Burcun &amp; Mizacın</h3><p><b>" + esc(durum.burc) + "</b> burcunun gök enerjisi, elinin gösterdiği <b>" + esc(f.ad.toLocaleLowerCase("tr")) + "</b> (" + esc(f.mizac.toLocaleLowerCase("tr")) + ") tabiatıyla birleşiyor. Bu iki yön iç dünyanı farklı açılardan aydınlatır; aşağıdaki taşlar tam da bu ikisini dengede tutmak için seçildi.</p>";

    E("frDenge").textContent = f.denge;
    E("frTaslar").innerHTML = f.taslar.map(function (t) { return '<div class="fr-tas-k"><span class="fr-tas-ad">' + esc(t[0]) + '</span><span class="fr-tas-anl">' + esc(t[1]) + "</span></div>"; }).join("");
    E("frSoz").innerHTML = '<span class="fr-soz-m">&#10077;</span>' + esc(f.soz);

    urunleriGetir(durum.unsur, durum.burc);
    var _tz = E("frTasarla"); if (_tz) { var _on = ((f.taslar) || []).map(function (t) { return t[0]; }); _tz.href = "/pages/kendin-tasarla?oneri=" + encodeURIComponent(_on.join(",")); try { localStorage.setItem("odt_oneri_taslar", JSON.stringify(_on)); } catch (e) {} }
    kaydet().then(function () { if (durum.kupon) kuponGoster(durum.kupon); });
  }

  /* ---------- Kimlik doğrula ---------- */
  function kimlikGecerli() {
    var ad = E("frAd").value.trim(), sy = E("frSoyad").value.trim();
    var g = parseInt(E("frGun").value, 10), a = parseInt(E("frAy").value, 10), y = parseInt(E("frYil").value, 10);
    var h = E("frKimlikHata");
    if (ad.length < 2) { h.textContent = "Adını yaz."; h.hidden = false; return false; }
    if (!g || !a || !y) { h.textContent = "Doğum tarihini seç."; h.hidden = false; return false; }
    h.hidden = true;
    durum.ad = ad; durum.soyad = sy; durum.gun = g; durum.ay = a; durum.yil = y; durum.burc = burcBul(g, a);
    return true;
  }

  /* ---------- Olaylar ---------- */
  kok.addEventListener("click", function (e) {
    var git = e.target.closest ? e.target.closest("[data-git]") : null;
    if (git) { var h = git.getAttribute("data-git"); if (h === "kimlik") { sahne("kimlik"); modelYukle().catch(function () {}); } if (h === "bas") { durum = { ad: "", soyad: "", gun: 0, ay: 0, yil: 0, kod: "", kupon: "", unsur: "", burc: "", olcum: null }; kameraKapat(); sahne("intro"); } return; }
    var sb = e.target.closest ? e.target.closest(".fr-sepet") : null;
    if (sb && !sb.disabled) { e.preventDefault(); sepeteEkle(sb.getAttribute("data-vid"), sb); return; }
  });

  // El modelini hazırla; başarısızsa butonu "Tekrar Dene"ye çevir (gerçek hatayı göster).
  function modelHazirla() {
    var b = E("frTara"); b.disabled = true; b.dataset.retry = ""; b.textContent = "Yükleniyor…";
    E("frKamDurum").textContent = "El modeli hazırlanıyor…";
    return modelYukle().then(function () {
      b.disabled = false; b.textContent = "Elimi Tara";
      E("frKamDurum").textContent = "Avucunu çerçeveye al · içi ekrana dönük · parmaklar açık";
      donguBasla();
    }).catch(function () {
      b.disabled = false; b.textContent = "↻ Tekrar Dene"; b.dataset.retry = "1";
      E("frKamDurum").textContent = "El modeli yüklenemedi" + (mpHata ? " · " + mpHata : "") + ". Bağlantını kontrol edip tekrar dene.";
    });
  }

  E("frKimlikDevam").addEventListener("click", function () {
    if (!kimlikGecerli()) return;
    sahne("kamera");
    var b = E("frTara"); b.disabled = true; b.textContent = "Elimi Tara"; b.dataset.retry = "";
    frameVar(false);
    E("frKamDurum").textContent = "Kamera açılıyor…";
    kameraAc().then(function () { modelHazirla(); })
      .catch(function () { E("frKamDurum").textContent = "Kameraya erişilemedi. Tarayıcıdan kamera iznini ver ve tekrar dene."; });
  });

  // Tara butonu: normalde o an görülen eli oku; model yüklenemediyse yeniden dener.
  E("frTara").addEventListener("click", function () {
    var b = E("frTara");
    if (b.dataset.retry === "1") { donguDur(); modelHazirla(); return; }
    if (tarama.aktif) return;
    if (canli.sonLm) taramaBasla();
    else E("frKamDurum").textContent = "Avucunu çerçeveye al · içi ekrana dönük · parmaklar açık";
  });
})();
